import { PolicyUpdateForm } from '@tomfxs/permissions-client'
import { useNavigate, useParams } from 'react-router-dom'
import { useCallback } from 'react'
import RouteContainer from 'src/components/App/RouteContainer'

export function PermissionsDetailsRoute() {
    const params = useParams<{ _id: string }>()
    const navigate = useNavigate()

    const onDeleted = useCallback(() => navigate('/settings/permissions'), [navigate])

    return (
        <RouteContainer>
            <PolicyUpdateForm policyId={params._id!} onDeleted={onDeleted} />
        </RouteContainer>
    )
}
